import * as React from 'react'
import { HelpCircle } from 'lucide-react'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

interface HelpHintProps {
  text: React.ReactNode
  className?: string
  side?: 'top' | 'right' | 'bottom' | 'left'
  iconSize?: number
}

export function HelpHint({ text, className, side = 'top', iconSize = 14 }: HelpHintProps) {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Help"
            className={cn(
              'inline-flex items-center justify-center rounded-full text-muted-foreground/60 hover:text-foreground transition-colors focus:outline-none focus:ring-1 focus:ring-ring',
              className,
            )}
          >
            <HelpCircle style={{ width: iconSize, height: iconSize }} aria-hidden="true" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-xs text-xs leading-relaxed">
          {text}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
